import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Receipt } from "lucide-react";

export default function AdminInvoices() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/payments/invoices").then(r => setItems(r.data || [])).catch(() => {}); }, []);
  return (
    <div>
      <h1 className="font-display text-2xl font-bold text-slate-900 mb-1">Fatture</h1>
      <p className="text-sm text-slate-600 mb-6">Gestione fatture e pagamenti.</p>
      <div className="cxo-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500">
            <tr><th className="p-3 text-left">Numero</th><th className="p-3 text-left">Data</th><th className="p-3 text-right">Importo</th><th className="p-3 text-left">Stato</th></tr>
          </thead>
          <tbody>
            {items.map(inv => (
              <tr key={inv.id} className="border-t border-slate-100">
                <td className="p-3 font-medium">{inv.number}</td>
                <td className="p-3 cxo-tabular">{inv.issue_date}</td>
                <td className="p-3 cxo-tabular text-right font-semibold">€{(inv.amount || 0).toLocaleString('it-IT')}</td>
                <td className="p-3"><Badge className={`border-0 ${inv.status === "paid" ? "bg-[#E9F8F1] text-[#1F9D6A]" : inv.status === "pending" ? "bg-amber-100 text-amber-700" : "bg-red-100 text-red-700"}`}>{inv.status}</Badge></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
